<div class="header">
    <button class="buttonBack" (click)="onClickClose($event)">
        <i class="fa fa-close"></i>
    </button>

</div>
<ng-container *ngIf="value">
    <shared-route-strip-component class="noSlot" [route]="value"></shared-route-strip-component>
    <div class="line" *ngIf="value.goods">
        <div class="line title">Carga</div>
        {{value.goods}}
    </div>
    <div class="line" *ngIf="value.customerReferences">
        <div class="line title">Otras referencias</div>
        {{value.customerReferences}}
    </div>
    <shared-active-slots-item-phase [phase]="phase"
        class="no-help showMarker noStatus noTags noDocks noVerificationCode" [hideLink]="true" [exwork]="true" [readonly]="true"
        *ngFor="let phase of value.phases | sortBy:'executionOrder'">
    </shared-active-slots-item-phase>
</ng-container>